import React, { useState, useEffect, useRef } from 'react';
import './styles/App.css';

import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';

import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Presence from './pages/Presence';
import Quality from './pages/Quality';
import Contact from './pages/Contact';

function App() {
  const [activePage, setActivePage] = useState('home');
  const [navScrolled, setNavScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = (page) => {
    setActivePage(page);
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => setNavScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderPage = () => {
    switch (activePage) {
      case 'home':     return <Home navigate={navigate} />;
      case 'products': return <Products navigate={navigate} />;
      case 'about':    return <About navigate={navigate} />;
      case 'presence': return <Presence navigate={navigate} />;
      case 'quality':  return <Quality />;
      case 'contact':  return <Contact />;
      default:         return <Home navigate={navigate} />;
    }
  };

  return (
    <>
      <CustomCursor />
      <Topbar />
      <Navbar
        activePage={activePage}
        navigate={navigate}
        navScrolled={navScrolled}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <main className="page-anim" key={activePage}>
        {renderPage()}
      </main>
      <Footer navigate={navigate} />
    </>
  );
}

export default App;
